








import { Component, Vue, Prop } from "vue-property-decorator";
import ProjectStatus from "@/components/ProjectStatus.vue";
import ProjectNewStatus from "./ProjectNewStatus.vue";
import { Project } from "@/api/project-api";
import { isNewProject } from "@/preferences";

@Component({
  components: {
    ProjectStatus,
    ProjectNewStatus
  }
})
export default class StatusPage extends Vue {
  @Prop({ required: true }) project!: Omit<Project, "createdAt"> & {
    createdAt: string;
  };
  @Prop({ default: "md" }) size!: string;

  get component() {
    const time = this.project.createdAt
      ? this.project.createdAt
      : this.project.created;

    return isNewProject(time) ? "ProjectNewStatus" : "ProjectStatus";
  }
}
